import React from "react";
import UserManagementPage from "../components/admin/user/UserManagementPage.jsx";

const AdminUserManagement = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* 헤더 */}
        <div
          style={{
            color: "white",
            padding: "20px 30px",
            position: "relative",
          }}
        >
          {/* 뒤로가기 버튼 */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "30px",
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <button
              onClick={() => window.location.href = '/admin'}
              style={{
                background: "rgba(255,255,255,0.2)",
                color: "white",
                border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: "6px",
                padding: "6px 12px",
                fontSize: "12px",
                cursor: "pointer",
                transition: "all 0.2s",
                backdropFilter: "blur(10px)",
              }}
              onMouseOver={(e) =>
                (e.target.style.background = "rgba(255,255,255,0.3)")
              }
              onMouseOut={(e) =>
                (e.target.style.background = "rgba(255,255,255,0.2)")
              }
            >
              ← 뒤로가기
            </button>
          </div>
          
          <div style={{ textAlign: "center" }}>
            <h1
              style={{
                margin: "0 0 5px 0",
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              👥 관리자 설정
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: "14px",
                opacity: 0.9,
              }}
            >
              시스템 관리자를 생성하고 관리하세요
            </p>
          </div>
        </div>

        {/* 내용 영역 */}
        <div
          style={{
            background: "white",
            borderRadius: "0 0 12px 12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            minHeight: "calc(100vh - 140px)",
          }}
        >
          <UserManagementPage />
        </div>
      </div>
    </div>
  );
};

export default AdminUserManagement;
